import React from 'react';
import { LanguagesBarProps } from './types';
import { Box, Tab, Tabs } from '@mui/material';
import './LanguagesBar.scss';

const LanguagesBar: React.FC<LanguagesBarProps> = (props) => {
    return (
        <Box className="languages-bar" sx={{ maxWidth: '100%', bgcolor: 'background.paper', fontSize: '1.4rem' }}>
            <Tabs
                value={props.selectedLanguage}
                onChange={(_: object, newLanguage: string) => {
                    props.handleChange(newLanguage);
                }}
                variant="scrollable"
                scrollButtons="auto"
            >
                {props.languages
                    ? props.languages.map((language) => (
                          <Tab label={language.name} key={language.code} value={language.code} />
                      ))
                    : null}
            </Tabs>
        </Box>
    );
};

export default LanguagesBar;
